import { render, staticRenderFns } from "./Cliente.vue?vue&type=template&id=6cd8f4b0&"
import script from "./Cliente.vue?vue&type=script&lang=ts&"
export * from "./Cliente.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6cd8f4b0', component.options)
    } else {
      api.reload('6cd8f4b0', component.options)
    }
    module.hot.accept("./Cliente.vue?vue&type=template&id=6cd8f4b0&", function () {
      api.rerender('6cd8f4b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plataforma/Cliente.vue"
export default component.exports